<template>
    <div class="layout-profile">
        <div>
            <Avatar icon="pi pi-user" size="large" shape="circle" />
        </div>
        <span class="username" style="color: white">{{ token_name || "" }}</span>
    </div>
</template>

<script>
    import {JwtToken} from "@/utils/jwt";

    export default {
        data() {
            return {
                expanded: false
            }
        },
        methods: {
            onClick(event) {
                this.expanded = !this.expanded;
                event.preventDefault();
            }
        },
        computed: {
            token_name() {
                return JwtToken.fromLocalStorage().name() || JwtToken.fromLocalStorage().email();
            }
        }
    }
</script>

<style scoped>

</style>
